import React, { useState, useEffect, useMemo } from 'react';
import { Link } from 'react-router';
import { MenuItemLink } from '../../common/components';
import { t } from '../i18n';
import MenuItem from './MenuItem';

let baseWeb = process.env.REACT_APP_WEB_URL
let homepageFolder = process.env.REACT_APP_HOMEPAGE_FOLDER

function useWindowSize() {
    const [windowSize, setWindowSize] = useState({
        width: undefined,
        height: undefined,
    })

    useEffect(() => {
        function handleResize() {
            setWindowSize({
                width: window.innerWidth,
                height: window.innerHeight,
            })
        }
        window.addEventListener("resize", handleResize)

        handleResize()

        return () => window.removeEventListener("resize", handleResize)
    }, [])

    return windowSize
}

const Header = (props) => {
    const [showMenu, setShowMenu] = useState(false)
    const { width } = useWindowSize()

    useEffect(() => {
        if (width && width > 1024) {
            setShowMenu(false)
        }

        //Check resize stuffs
        const classes = document.body.classList

        classes.add('resizing');

        setTimeout(() => {
            classes.remove('resizing')
        }, 100)
    }, [width])

    useEffect(() => {
        if (showMenu) {
            document.body.classList.add("menuopen")
        } else {
            document.body.classList.remove("menuopen")
        }
    }, [showMenu])

    useEffect(() => {
        window.onscroll = () => {
            let st = document.documentElement.scrollTop

            if (st > 0) {
                document.body.classList.add("scrolled")
            } else {
                document.body.classList.remove("scrolled")
            }
        }
    }, [])

    const menu = useMemo(() => {
        if (props.isLoggedIn) {
            return (
                <ul className="topmenu">
                    {(props.isDebtor || props.isCreditor || props.isExecutor) ? (
                        <MenuItem
                            path={`/${homepageFolder}/#/dashboard/settings`}
                            title='Nastavenia'
                            onClick={() => setShowMenu(false)}
                            preventDefault={false}
                        />
                    ) : null}
                    {(props.isDebtor || props.isCreditor || props.isExecutor) ? (
                        <MenuItem
                            path={`/${homepageFolder}/#/pomoc`}
                            title='Formulár pomoc'
                            onClick={() => setShowMenu(false)}
                            preventDefault={false}
                        />
                    ) : null}
                    <MenuItem
                        path={`/`}
                        title='Odhlásiť sa'
                        onClick={() => {
                            setShowMenu(false)
                            props.logout()
                        }}
                        preventDefault={true}
                    />
                </ul>
            )
        } else {
            return (
                <ul className="topmenu">
                    <MenuItem
                        path={baseWeb + "/investicie"}
                        title='Investície'
                        onClick={() => setShowMenu(false)}
                        preventDefault={false}
                        submenu={[
                            {
                                path: baseWeb + '/investicie',
                                title: 'Dôvody prečo investovať'
                            },
                            {
                                path: baseWeb + '/investicie#proces-investovania',
                                title: 'Proces investovania'
                            },
                            {
                                path: baseWeb + '/investicie#garancie-a-bezpecnost',
                                title: 'Garancie a bezpečnosť'
                            },
                            {
                                path: baseWeb + '/investicie/poplatky-dane-odvody',
                                title: 'Poplatky, dane a odvody'
                            },
                            {
                                path: baseWeb + '/investicie/najcastejsie-otazky',
                                title: 'Najčastejšie otázky investorov'
                            }
                        ]}
                    />
                    <MenuItem
                        path={baseWeb + "/pozicky"}
                        title='Pôžičky'
                        onClick={() => setShowMenu(false)}
                        preventDefault={false}
                        submenu={[
                            {
                                path: baseWeb + '/pozicky',
                                title: 'Ako si požičať'
                            },
                            {
                                path: baseWeb + '/pozicky#poplatky',
                                title: 'Poplatky'
                            },
                            {
                                path: baseWeb + '/pozicky/najcastejsie-otazky',
                                title: 'Najčastejšie otázky k pôžičkám'
                            }
                        ]}
                    />

                    <MenuItem
                        path={baseWeb + "/o-nas"}
                        title='O nás'
                        preventDefault={false}
                        onClick={() => setShowMenu(false)}
                    />
                </ul>
            )
        }
    }, [props.isLoggedIn, baseWeb, props.isDebtor, props.isCreditor, props.isExecuto])

    return (
        <header id="mainAppHeader" className="header">
            <div className="header_outer">
                <div className="header_inner">
                    <div className="header_content">

                        <a href={props.isLoggedIn ? '/' + homepageFolder + '/#/dashboard/overview' : baseWeb + '/'} title="Maják" className="header_logo element_logo">
                            <svg className="sico" role="img">
                                <title>Maják</title>
                                <g><use xlinkHref="/assets/icons.svg#s_logo_p1" /></g>
                                <g><use xlinkHref="/assets/icons.svg#s_logo_p2" /></g>
                            </svg>
                        </a>

                        <div className="nav_cont">

                            <button type="button" className="nav_button toggle-menu" aria-label={`${showMenu ? 'Skryť menu' : 'Zobraziť menu'}`} onClick={() => setShowMenu(!showMenu)}>
                                <span className="icon_menu"></span>
                            </button>

                            <nav className="nav">
                                {menu}
                            </nav>
                        </div>

                        <div className="header_right">
                            <a
                                href={props.isLoggedIn ? '/' + homepageFolder + '/#/dashboard/overview' : '/' + homepageFolder + '/#/auth/login'}
                                title="Klientska sekcia"
                                className="header_login"
                            >
                                <svg className="sico">
                                    <g><use xlinkHref="/assets/icons.svg#s_login_p1" /></g>
                                    <g><use xlinkHref="/assets/icons.svg#s_login_p2" /></g>
                                </svg>
                                {props.isLoggedIn ? (
                                    <span>{props.email}</span>
                                ) : (
                                    <span>Prihlásiť sa</span>
                                )}
                            </a>
                            {props.isLoggedIn ? (
                                <div className="dropdown">
                                    <div className="wrapper">
                                        {(props.isCreditor || props.isDebtor || props.isExecutor) && (
                                            <a href={'/' + homepageFolder + '/#/dashboard/settings'} key="settings">
                                                {t('Nastavenia')}
                                            </a>
                                        )}
                                        {(props.isCreditor || props.isDebtor || props.isExecutor) && (
                                            <a href={'/' + homepageFolder + '/#/pomoc'} key="help">
                                                {t('Formulár pomoc')}
                                            </a>
                                        )}
                                        <div className="item" key="logout">
                                            <Link onClick={() => props.logout()}>{t('Odhlásiť')}</Link>
                                        </div>
                                    </div>
                                </div>
                            ) : null}
                        </div>

                    </div>
                </div>
            </div>
        </header>
    )
}

export default Header


// WEBPACK FOOTER //
// ./src/app/components/Header.js